export const Base_Url = 'https://ailemiz.az/api';